import './App.css';
import { useState } from 'react';

function App() {
  const [activeSection, setActiveSection] = useState('about');

  const handleHomeClick = () => {
    window.open('https://www.pirlantatekstil.com/', '_blank');
  };

  const handleAboutClick = () => {
    setActiveSection('about');
  };

  return (
    <div className="App">
      {/* Toolbar */}
      <header className="toolbar">
        <div className="toolbar-content">
          <div className="logo-container">
            <img 
              src="https://www.pirlantatekstil.com/themes/pirlantatekstil/assets/img/logo-2.svg" 
              alt="Pirlanta Tekstil Logo" 
              className="logo"
            />
          </div>
          <nav className="navigation">
            <button 
              className="nav-button home-button" 
              onClick={handleHomeClick}
            >
              Strona główna
            </button>
            <button 
              className="nav-button about-button" 
              onClick={handleAboutClick}
            >
              O nas
            </button>
          </nav>
        </div>
      </header>

      {/* Main Content */}
      <main className="main-content">
        {activeSection === 'about' && (
          <section className="about-section">
            <div className="about-content">             
              
              {/* Pierwsza Sekcja - Hero Section */}
              <div className="hero-section">
                <div className="hero-text">
                  <h2>Pırlanta Tekstil – w Polsce – O nas</h2>
                  <p>
                    Pırlanta Tekstil to wiodąca marka, która łączy wieloletnie doświadczenie w produkcji i projektowaniu w sektorze tekstyliów domowych. Z naszej siedziby w Stambule nasze produkty trafiają na cały świat, wzbogacając przestrzenie mieszkalne poprzez połączenie nowoczesnej estetyki z tradycyjną elegancją.
                  </p>
                  <p>
                    Dla nas tekstylia to nie tylko produkcja tkanin, ale także tworzenie wartości kulturowej. Każdy nasz produkt jest starannie przygotowany, aby spełniał międzynarodowe standardy pod względem jakości i estetyki.
                  </p>
                </div>
                <div className="hero-image">
                  <img 
                    src="https://www.pirlantatekstil.com/uploads/pages/3/image-1-tr_TR.jpg?_=1668600552" 
                    alt="Pırlanta Tekstil Interior" 
                    className="hero-img"
                  />
                </div>
              </div>

              {/* Druga Sekcja - Nasza Wizja */}
              <div className="animation-section">
                <div className="animation-container">
                  <div className="animation-image">
                    <img 
                      src="https://www.pirlantatekstil.com/uploads/pages/3/image-2-tr_TR.jpg?_=1668600552" 
                      alt="Pırlanta Tekstil Production" 
                      className="main-animation-img"
                    />
                    <div className="floating-bubble">
                      <img 
                        src="https://www.pirlantatekstil.com/uploads/pages/3/image-3-tr_TR.jpg?_=1668600552" 
                        alt="Floating Element" 
                        className="bubble"
                      />
                    </div>
                  </div>
                  <div className="animation-text">                                      
                    <h2>Nasza wizja</h2>
                    <p>
                      Do końca czwartego kwartału 2026 roku planujemy założyć nasze centrum logistyczne w Polsce i wejść na rynek. Ten krok to nie tylko nowa inwestycja, ale także część naszej wizji połączenia głęboko zakorzenionej kultury handlowej Polski z turecką tradycją tekstylną.
                    </p>
                    <p>
                      Będziemy wysyłać Twoje zamówienia dwa razy w tygodniu (wtorek i piątek) ze Stambułu i dostarczać je do Twoich drzwi w zaledwie 5 dni. Do tej pory żadna turecka firma nie oferowała takiej usługi w Polsce.
                    </p>                   
                  </div>
                </div>
              </div>

              {/* Trzecia Sekcja - Nasze Podejście */}
              <div className="references-section">
                <div className="reference-item">
                  <div className="reference-icon">
                    <img 
                      src="https://www.pirlantatekstil.com/uploads/pages/3/widget-1-image-tr_TR.jpg?_=1668600552" 
                      alt="Strategiczne Podejście" 
                      className="reference-logo"
                    />
                  </div>
                  <h3>Strategiczne podejście</h3>
                  <p>Będziemy wysyłać Twoje zamówienia dwa razy w tygodniu (wtorek i piątek) ze Stambułu i dostarczać je do Twoich drzwi w zaledwie 5 dni. Dzięki naszej filozofii handlu, która znosi odległości, czynimy to możliwym.</p>
                </div>
                <div className="reference-item">
                  <div className="reference-icon">
                    <img 
                      src="https://www.pirlantatekstil.com/uploads/pages/3/widget-2-image-tr_TR.jpg?_=1668600552" 
                      alt="Dlaczego Polska" 
                      className="reference-logo"
                    />
                  </div>
                  <h3>Dlaczego Polska?</h3>
                  <p>Polska to dynamiczny i rozwijający się rynek z silną siecią handlową w sercu Europy. Znaczenie, jakie przywiązuje się do dekoracji wnętrz, stale podnosi oczekiwania klientów.</p>
                </div>
                <div className="reference-item">
                  <div className="reference-icon">
                    <img 
                      src="https://www.pirlantatekstil.com/uploads/pages/3/widget-3-image-tr_TR.jpg?_=1668600552" 
                      alt="Nasze Partnerstwa" 
                      className="reference-logo"
                    />
                  </div>
                  <h3>Nasze partnerstwa</h3>
                  <p>Cieszymy się, że możemy gościć w naszej sieci usług firmy, które cenią tekstylia domowe i inwestują w jakość. W tym roku z dumą uczestniczymy w targach Targi Home.</p>
                </div>
              </div>

              {/* Sekcja Obietnic */}
              <div className="promises-section">
                <div className="promises-content">
                  <h2>Nasza obietnica</h2>
                  <div className="promises-grid">
                    <div className="promise-item">
                      <h3>Dostawa ze Stambułu do Warszawy w 5 dni</h3>
                      <p>Nasze centrum logistyczne w Polsce zapewni naszym klientom szybkość i bezpieczeństwo w krótkim okresie.</p>
                    </div>
                    <div className="promise-item">
                      <h3>Produkcja, która ceni jakość</h3>
                      <p>Nigdy nie idziemy na kompromisy w kwestii jakości. Każdy produkt spełnia międzynarodowe standardy.</p>
                    </div>
                    <div className="promise-item">
                      <h3>Projekty łączące estetykę</h3>
                      <p>Łączymy nowoczesną i tradycyjną estetykę, tworząc unikalne rozwiązania tekstylne.</p>
                    </div>
                    <div className="promise-item">
                      <h3>Zaufanie i współpraca</h3>
                      <p>Tworzymy nową wspólną historię sukcesu, łącząc polską kulturę handlową z turecką przedsiębiorczością.</p>
                    </div>
                  </div>
                </div>
              </div>

              {/* Czwarta Sekcja - Kontakt i Mapa */}
              <div className="contact-section">
                <div className="contact-header">
                  <img 
                    src="https://www.pirlantatekstil.com/themes/pirlantatekstil/assets/img/logo.svg" 
                    alt="Pırlanta Tekstil Logo" 
                    className="contact-logo"
                  />
                </div>
                <div className="contact-info">
                  <div className="contact-item">
                    <h3>Address</h3>
                    <p>Aksaray Neighborhood, Namık Kemal Street, Kule Boyu Street No:3 Fatih/Istanbul</p>
                    <p><strong>Email:</strong> sprzedaz@pirlantatekstil.com</p>
                    <p><strong>Contact:</strong> +90 (212) 528 02 02</p>
                  </div>
                  <div className="contact-item">
                    <h3>Oddziały</h3>
                    <p>Istanbul-Bursa-Kiev-Moscow</p>
                  </div>
                  <div className="contact-item">
                    <h3>Media społecznościowe</h3>
                    <div className="social-links">
                      <a href="https://www.instagram.com/pirlantatextile.official?igsh=YTMwZGMwbXhtcTF5&utm_source=qr" target="_blank" rel="noopener noreferrer">
                        <img src="https://cdn-icons-png.flaticon.com/512/2111/2111463.png" alt="Instagram" className="social-icon" />
                        Instagram
                      </a>
                      <a href="https://wa.me/+905432931420" target="_blank" rel="noopener noreferrer">
                        <img src="https://cdn-icons-png.flaticon.com/512/733/733585.png" alt="WhatsApp" className="social-icon" />
                        WhatsApp
                      </a>
                    </div>
                  </div>
                </div>
                <div className="map-container">
                  <iframe 
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3010.123456789!2d28.123456789!3d41.123456789!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zNDHCsDA3JzI0LjQiTiAyOMKwMDcnMjQuNCJF!5e0!3m2!1str!2str!4v1234567890123!5m2!1str!2str"
                    width="100%" 
                    height="400" 
                    style={{border: 0}} 
                    allowFullScreen="" 
                    loading="lazy" 
                    referrerPolicy="no-referrer-when-downgrade"
                    title="Pırlanta Tekstil Konum Haritası"
                  ></iframe>
                </div>
              </div>
            </div>
          </section>
        )}
        
        {activeSection === 'home' && (
          <section className="home-section">
            <div className="home-content">
              <h1>Pirlanta Tekstil'e Hoş Geldiniz</h1>
              <p>Lüks tül ve perde koleksiyonlarımızı keşfedin.</p>
            </div>
          </section>
        )}
      </main>
    </div>
  );
}

export default App;
